export type InstallPlatform = "ios" | "android" | "desktop";
export const installDismissalMs = 30 * 24 * 60 * 60 * 1000;

export function installPlatform(
  userAgent: string,
  touchPoints = 0,
): InstallPlatform {
  if (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && touchPoints > 1)
  )
    return "ios";
  return /Android/i.test(userAgent) ? "android" : "desktop";
}

export function shouldInviteInstall(input: {
  platform: InstallPlatform;
  installed: boolean;
  dismissedAt: number;
  now: number;
  blocked: boolean;
}): boolean {
  return (
    input.platform !== "desktop" &&
    !input.installed &&
    !input.blocked &&
    (!input.dismissedAt || input.now - input.dismissedAt >= installDismissalMs)
  );
}
